import {
  ElementsSvg,
  FolderSvg,
  LanguageIcon,
  TemplateSvg,
  ComplexDesignSvg,
  businessLogicSvg,
  PreviewIcon,
  channelIcon,
} from '../../components/SidebarMenuIcons';
import { AccessibilitySvgIcon } from '../../images/svgIcons';
import { BUSINESS_LOGIC_TAB, COMPLEX_DOC_SIDEBAR } from '../ComplexDocumentDesign/translationValues';
import { DESIGN_AREA_SIDEBAR_MENUS } from '../SidebarMenu/translationValues';

export const ComplexDesignTabs = (t, currentDesign, isDesigner) => {
  return [
    {
      id: 2,
      label: t(COMPLEX_DOC_SIDEBAR.LETS_DESIGN_TAB_TOOLTIP.key, COMPLEX_DOC_SIDEBAR.LETS_DESIGN_TAB_TOOLTIP.value),
      icon: ComplexDesignSvg,
      className: undefined
    },
    {
      id: 11,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.value),
      icon: TemplateSvg,
      className: undefined,
    },
    {
      id: 12,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.value),
      icon: ElementsSvg,
      className: undefined,
    },
    {
      id: 7,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.value),
      icon: FolderSvg,
      className: undefined,
    },
    {
      id: 8,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.EMAIL_SETTINGS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.EMAIL_SETTINGS_TAB_TOOLTIP.value),
      type: 'setting',
      className: 'settings-icon',
    },
    ...currentDesign === 'document' ?
    [{
      id: 14,
      label: t(DESIGN_AREA_SIDEBAR_MENUS.EMAIL_ATTACHMENT_SETTINGS_TAB_TOOLTIP.key, DESIGN_AREA_SIDEBAR_MENUS.EMAIL_ATTACHMENT_SETTINGS_TAB_TOOLTIP.value),
      type: 'link',
      className: 'settings-icon',
    }] : [],
    ...currentDesign !== 'document' ?
      [{
        id: 9,
        label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.value),
        icon: LanguageIcon,
        className: 'settings-icon',
      }] : [],
    ...currentDesign === 'document' ?
      [
      {
        id: 15,
        label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.CHANNEL_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.CHANNEL_TOOLTIP.value),
        icon: channelIcon,
        className: 'channel-icon',
      },
      {
        id: 13,
        label: t(BUSINESS_LOGIC_TAB.BUSINESS_LOGIC_LABEL.key, BUSINESS_LOGIC_TAB.BUSINESS_LOGIC_LABEL.value),
        icon: businessLogicSvg,
        className: 'business-logic'
      }] : [],
    {
      id: 16,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.ACCESSIBILITY_DESIGN.key}`, DESIGN_AREA_SIDEBAR_MENUS.ACCESSIBILITY_DESIGN.value),
      icon: AccessibilitySvgIcon,
      className: 'accessibility-design'
    },
    {
      id: 10,
      label: isDesigner && currentDesign === 'document'
        ? t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_AND_SEND_EMAIL_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_AND_SEND_EMAIL_TOOLTIP.value)
        : t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_TOOLTIP.value),
      icon: PreviewIcon,
      className: 'variables',
      className: 'business-logic'
    },
  ];
};